<template>
  <div ref="articleReadRef"></div>
</template>

<script>
import { defineComponent, inject, ref } from '@nuxtjs/composition-api';
import { useInfiniteScroll } from '~/composables/useInfiniteScroll';

export default defineComponent({
  setup(props, { emit }) {
    const readList = ref({});
    const article = inject('article');
    const [articleReadRef] = useInfiniteScroll(() => {
      if (!readList.value[article.legacyId]) {
        readList.value[article.legacyId] = true;
        emit('on-screen');
      }
    });
    return { articleReadRef };
  },
});
</script>
